import { DrawerPanel } from '@dmc/ui';
import { useRenderKey } from '@casops/hooks/useRenderKey';
import SafetySettingsForm from './components/settings-form/SafetySettingsForm';
import { ReactElement } from 'react';
import { useGetPersonnelSafetySettingsQuery } from '@casops/store/apis/settingsApi';
import { useTranslation } from 'react-i18next';

export function ManageSafetySettings(): ReactElement {
  const { t } = useTranslation();

  const { currentData: item, isSuccess, fulfilledTimeStamp } = useGetPersonnelSafetySettingsQuery();

  // Base the renderKey on all data that can change, including roles.
  const renderKey = useRenderKey({ fulfilledTimeStamp });

  return (
    <DrawerPanel isLoaded={isSuccess} header={t('Settings')}>
      <SafetySettingsForm key={renderKey} settings={item} />
    </DrawerPanel>
  );
}

export default ManageSafetySettings;
